import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { connect } from 'react-redux';
import style from './SchoolPrograms.scss';
import SchoolProgram from '../SchoolProgram';

class SchoolPrograms extends Component {
  static defaultProps = {
    loggedIn: false,
    name: '',
    programOpen: 0,
    singleProgramId: false,
    firstName: null,
    showDetails: false,
    scheduleProgram: null,
    initScheduling: null,
    removeNoMatchingTimeSlot: null,
    school: null,
    admissionProcess: null,
    isAffiliatedSRLocation: false,
    zonedSchool: false,
  };
  static propTypes = {
    programs: PropTypes.shape().isRequired,
    applyCard: PropTypes.bool.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    loggedIn: PropTypes.bool,
    name: PropTypes.string,
    programOpen: PropTypes.number,
    programClick: PropTypes.func.isRequired,
    singleProgramId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    firstName: PropTypes.string,
    showDetails: PropTypes.bool,
    url: PropTypes.string.isRequired,
    scheduleProgram: PropTypes.shape(),
    initScheduling: PropTypes.func,
    removeNoMatchingTimeSlot: PropTypes.func,
    school: PropTypes.shape({
      name: PropTypes.string,
    }),
    admissionProcess: PropTypes.string,
    admissions_open: PropTypes.bool,
    waitlist_open: PropTypes.bool,
    results_enabled: PropTypes.bool,
    isAffiliatedSRLocation: PropTypes.bool,
    zonedSchool: PropTypes.bool,
  };

  render() {
    const {
      applyCard,
      id,
      name,
      loggedIn,
      programs,
      programOpen,
      showDetails,
      singleProgramId,
      url,
      programClick,
      scheduleProgram,
      initScheduling,
      school,
      removeNoMatchingTimeSlot,
      admissionProcess,
      admissions_open,
      waitlist_open,
      results_enabled,
      switches,
      isAffiliatedSRLocation,
    } = this.props;

    if (singleProgramId !== false) {
      return (
        <ul className={style.root}>
          <li className={style.item} key={`program-${programs[singleProgramId]}`}>
            <SchoolProgram
              is_last_school={singleProgramId}
              {...programs.entities.program[singleProgramId]}
              schoolId={id}
              schoolUrl={url}
              schoolName={school.name}
              loggedIn={loggedIn}
              showDetails={showDetails}
              applyCard={applyCard}
              programClick={programClick}
              firstName={name}
              singleProgramCard
              scheduleProgram={scheduleProgram}
              initScheduling={initScheduling}
              removeNoMatchingTimeSlot={removeNoMatchingTimeSlot}
              school={school}
              admissionProcess={admissionProcess}
              admissionsOpen={admissions_open}
              waitlistOpen={waitlist_open}
              resultsEnabled={results_enabled}
              isAffiliatedSRLocation={isAffiliatedSRLocation}
              switches={switches}
            />
          </li>
        </ul>
      );
    }
    return (
      <ul className={style.root}>
        {programs.result.map((program, index) => {
          let currentProgram = 0;
          if (program === programOpen) {
            currentProgram = program;
          }

          return (
            <li data-coachmark={index === 0 ? 'search-step-3' : ''} className={style.item} key={`program-${program}`}>
              <SchoolProgram
                is_last_school={this.props.is_last_school}
                {...programs.entities.program[program]}
                programOpen={currentProgram}
                schoolId={id}
                schoolName={school.name}
                loggedIn={loggedIn}
                schoolUrl={url}
                showDetails={showDetails}
                applyCard={applyCard}
                programClick={programClick}
                firstName={name}
                scheduleProgram={scheduleProgram}
                initScheduling={initScheduling}
                removeNoMatchingTimeSlot={removeNoMatchingTimeSlot}
                school={school}
                admissionProcess={admissionProcess}
                admissionsOpen={admissions_open}
                waitlistOpen={waitlist_open}
                resultsEnabled={results_enabled}
                isAffiliatedSRLocation={isAffiliatedSRLocation}
                switches={switches}
              />
            </li>
          );
        })}
      </ul>
    );
  }
}

const mapState = state => ({ saved: state.user.savedPrograms, name: state.user.firstName });
export default connect(mapState)(withStyles(style)(SchoolPrograms));
